// extracted by mini-css-extract-plugin
export var card = "_jl-5";
export var cardSelected = "_jl-4";
export var image = "_jl-3";
export var modal = "_jl-0";
export var modalContent = "_jl-1";
export var table = "_jl-2";